import type { EnrichedFilter } from '@/feature/product/types/referencesProduct'
import type { ReferencesProductFilters_FiltersFragment } from '@gql-generated/graphql'
import { atom } from 'jotai'
import { atomWithReset } from 'jotai/utils'
import type { MergedArticle } from '../types/mergedProduct'

export const referencesProductArticlesAtom = atom<MergedArticle[]>([])

export const referencesProductArticlesFilteredAtom = atom<MergedArticle[]>([])

export const referencesProductArticlesFilteredReferencesAtom = atom<string[]>([])

export const referencesProductFiltersAtom = atom<ReferencesProductFilters_FiltersFragment[]>([])

export const referencesProductFiltersEnrichedAtom = atomWithReset<EnrichedFilter[]>([])

export const referencesProductSelectableColumnsAtom = atomWithReset<string[]>([])

export const referencesProductSelectedColumnsAtom = atomWithReset<string[]>([])

export const referencesProductArticleDetailShownAtom = atomWithReset<string | null>(null)

export const referencesProductIsMonoDiscriminantAtom = atom<boolean>(false)
